import { FC } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import clsx from "classnames";
import { useStyles } from "./BottomTabBar.style";
import { Icon } from "../../core/Icon/Icon";
import { PageRoutes } from "../../../constants/routes";

const tabs = [
  { icon: "icon-bold-console", path: PageRoutes.Home },
  { icon: "icon-gamepad-bold", path: PageRoutes.EssentialPass },
  { icon: "icon-bold-game-store", path: PageRoutes.InstallGame },
  { icon: "icon-bold-search-normal", path: PageRoutes.Search },
  { icon: "icon-setting", path: PageRoutes.Settings },
];

export const BottomTabBar: FC = () => {
  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className={classes.root}>
      {tabs.map((tab) => (
        <div
          key={tab.path}
          className={clsx(classes.item, {
            [classes.itemActive]: location.pathname === tab.path,
          })}
          data-selected-class={classes.selected}
          data-gamepad={`menu-${tab.path}`}
          onClick={() => navigate(tab.path)}
        >
          <Icon name={tab.icon} size={24} />
        </div>
      ))}
    </div>
  );
};
